import { render, staticRenderFns } from "./FacilitiesItems.vue?vue&type=template&id=27ccd41e&scoped=true"
import script from "./FacilitiesItems.vue?vue&type=script&lang=ts"
export * from "./FacilitiesItems.vue?vue&type=script&lang=ts"
import style0 from "./FacilitiesItems.vue?vue&type=style&index=0&id=27ccd41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ccd41e",
  null
  
)

export default component.exports